var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<label class=\"toggle-switch\" ng-init=\"$ctrl.selected=$ctrl.filter.isSelected({tagLabel: $ctrl.filter.tagLabel})\"><input type=\"checkbox\" ng-model=\"$ctrl.selected\" ng-change=\"$ctrl.toggle({tagLabel: $ctrl.filter.tagLabel})\"/> <span class=\"toggle-slider\"></span></label> <span>{{$ctrl.filter.title||$ctrl.filter.tag}}</span>";
var id1="auto-query-tag-filter.toggle-switch.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;